import React from 'react';
import { BounceLoader
} from 'react-spinners'; // You can choose other spinners as well

const Spinner = () => {
  return (
    // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
      <BounceLoader
      color="#0a384f" loading={true} size={40} />
    // </div>
  );
};

export default Spinner;
